<div class="assignment-info">
  <!-- Content like Load Units -->
  <div class="content">
    <div class="assignment-section">
      @if (isLoading()) {
        <app-loader></app-loader>
      } @else {
        <dx-data-grid
          id="loadunits-grid"
          [dataSource]="loadunits() ?? []"
          keyExpr="ID"
          [showRowLines]="true"
          [showColumnLines]="false"
          [showBorders]="false"
          [allowColumnReordering]="false"
          [allowColumnResizing]="true"
          style="width: 100%"
          (onRowDblClick)="handleCellClick($event)"
          height="100%">
          <dxo-paging [pageSize]="120"></dxo-paging>
          <dxo-scrolling
            mode="infinite"
            [useNative]="false"
            [scrollByContent]="true"
            [scrollByThumb]="true"
            showScrollbar="onHover">
          </dxo-scrolling>
          <dxo-paging [pageSize]="10"></dxo-paging>
          <dxo-scrolling mode="virtual"></dxo-scrolling>
          <dxi-column
            dataField="LoadunitName"
            [allowSorting]="false"
            [caption]="'MASTERDATA.LOADUNIT.DTO.NAME' | translate"
            alignment="center"></dxi-column>
          <dxi-column
            dataField="Sortierung"
            [allowSorting]="false"
            [caption]="'MASTERDATA.LOADUNIT.DTO.SORTIERUNG' | translate"
            alignment="center"></dxi-column>
          <dxi-column
            dataField="TrapoProjektNr"
            [allowSorting]="false"
            [caption]="'MASTERDATA.LOADUNIT.DTO.TRANS_PR' | translate"
            alignment="center"></dxi-column>
          <dxi-column
            dataField="VehicleDisplayName"
            [allowSorting]="false"
            [caption]="'MASTERDATA.LOADUNIT.DTO.VEHICLE_DISPLAY_NAME' | translate"></dxi-column>
        </dx-data-grid>
      }
    </div>
  </div>
</div>
